document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initFaq();
  initStickyBar();
  initCountdown();
  initGalerias();
});

function initReveals() {
  var els = document.querySelectorAll('.kc-reveal, .kc-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('kc-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('kc-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.kc-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.kc-faq-pregunta');
    var respuesta = item.querySelector('.kc-faq-respuesta');
    if (!btn || !respuesta) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('kc-faq-abierto');
      items.forEach(function (otro) {
        otro.classList.remove('kc-faq-abierto');
        var r = otro.querySelector('.kc-faq-respuesta');
        if (r) r.style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('kc-faq-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initCountdown() {
  var cajas = document.querySelectorAll('[data-kc-countdown]');
  if (!cajas.length) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  cajas.forEach(function (caja) {
    var horaFin = caja.getAttribute('data-fin-hora') || '23:59';
    var partes = horaFin.split(':');
    var horas = parseInt(partes[0], 10);
    var minutos = parseInt(partes[1], 10);
    if (isNaN(horas)) horas = 23;
    if (isNaN(minutos)) minutos = 59;

    var digitos = caja.querySelector('[data-kc-countdown-activo]');
    var finMsg = caja.querySelector('[data-kc-countdown-fin]');
    var elH = caja.querySelector('[data-kc-h]');
    var elM = caja.querySelector('[data-kc-m]');
    var elS = caja.querySelector('[data-kc-s]');
    var intervalo = null;

    function tick() {
      var ahora = new Date();
      // Objetivo: la hora de fin de HOY (día del visitante). Al pasar esa
      // hora se muestra "finalizada" el resto del día — no se reinicia con
      // cada recarga de página ni muestra números negativos.
      var fin = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), horas, minutos, 59, 999);
      var restanteMs = fin.getTime() - ahora.getTime();

      if (restanteMs <= 0) {
        if (digitos) digitos.hidden = true;
        if (finMsg) finMsg.hidden = false;
        return false;
      }

      var totalSegundos = Math.floor(restanteMs / 1000);
      var h = Math.floor(totalSegundos / 3600);
      var m = Math.floor((totalSegundos % 3600) / 60);
      var s = totalSegundos % 60;

      if (elH) elH.textContent = pad(h);
      if (elM) elM.textContent = pad(m);
      if (elS) elS.textContent = pad(s);
      return true;
    }

    if (tick()) {
      intervalo = setInterval(function () {
        if (!tick() && intervalo) {
          clearInterval(intervalo);
        }
      }, 1000);
    }
  });
}

function initGalerias() {
  var galerias = document.querySelectorAll('[data-kc-galeria]');
  if (!galerias.length) return;

  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-kc-galeria-principal]');
    var wrap = galeria.closest('.kc-hero-grid') || galeria.parentElement;
    var miniaturasWrap = wrap ? wrap.querySelector('[data-kc-miniaturas]') : null;
    var minis = miniaturasWrap ? Array.prototype.slice.call(miniaturasWrap.querySelectorAll('[data-kc-mini]')) : [];
    if (!principal || !minis.length) return;

    var indiceActual = minis.findIndex(function (m) { return m.classList.contains('kc-miniatura-activa'); });
    if (indiceActual < 0) indiceActual = 0;

    function irA(indice) {
      if (indice < 0) indice = minis.length - 1;
      if (indice >= minis.length) indice = 0;
      if (indice === indiceActual) return;
      indiceActual = indice;
      var nuevaSrc = minis[indiceActual].getAttribute('data-src');
      principal.classList.add('kc-galeria-cargando');
      window.setTimeout(function () {
        principal.src = nuevaSrc;
        principal.classList.remove('kc-galeria-cargando');
      }, 150);
      minis.forEach(function (m, i) { m.classList.toggle('kc-miniatura-activa', i === indiceActual); });
    }

    minis.forEach(function (mini, i) {
      mini.addEventListener('click', function () { irA(i); });
    });

    var flechaPrev = galeria.querySelector('[data-kc-flecha="prev"]');
    var flechaNext = galeria.querySelector('[data-kc-flecha="next"]');
    if (flechaPrev) flechaPrev.addEventListener('click', function () { irA(indiceActual - 1); });
    if (flechaNext) flechaNext.addEventListener('click', function () { irA(indiceActual + 1); });

    // Swipe táctil/puntero para pasar de imagen en móvil y escritorio.
    var xInicio = null;
    galeria.addEventListener('pointerdown', function (e) {
      xInicio = e.clientX;
      try { galeria.setPointerCapture(e.pointerId); } catch (err) {}
    });
    galeria.addEventListener('pointerup', function (e) {
      if (xInicio === null) return;
      var deltaX = e.clientX - xInicio;
      xInicio = null;
      if (Math.abs(deltaX) < 40) return;
      if (deltaX < 0) { irA(indiceActual + 1); } else { irA(indiceActual - 1); }
    });
    galeria.addEventListener('pointercancel', function () { xInicio = null; });
  });
}

function initStickyBar() {
  var bar = document.querySelector('.kc-sticky-bar');
  var hero = document.querySelector('[data-kc-hero-anchor]');
  if (!bar || !hero) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        bar.classList.remove('kc-sticky-visible');
      } else if (entry.boundingClientRect.top < 0) {
        bar.classList.add('kc-sticky-visible');
      } else {
        bar.classList.remove('kc-sticky-visible');
      }
    });
  }, { threshold: 0 });
  obs.observe(hero);
}
